import { Box } from '@mui/material'
import PhaseCard from './PhaseCard'
import { phaseListSx } from './phaseListSx'

/**
 * A phased plan, inferred from the `### Phase n - name - timeframe` convention.
 *
 * Degraded states (audit C5):
 *  - fewer than two phases → the rule declines to match, so this never renders
 *    a one-card list; the text stays markdown.
 *  - a phase with no body → heading row only, which is still a valid card.
 *  - a phase with no timeframe → the chip is omitted rather than left empty.
 *
 * @param {{ block: { phases: Array<{ index: number, name: string }> } }} props
 */
export default function PhaseListBlock({ block }) {
  const phases = block?.phases ?? []
  if (phases.length < 2) return null

  return (
    <Box sx={phaseListSx}>
      {phases.map((phase) => (
        <PhaseCard key={`phase-${phase.index}-${phase.name}`} phase={phase} />
      ))}
    </Box>
  )
}
